import update from "immutability-helper";
import {
  ITreePickerChildren,
  ITreePickerElement
} from "./../../../interfaces/tree-picker.interface";
import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  OnChanges,
  SimpleChanges
} from "@angular/core";
import { generateRandomString } from "../../../functions";
import { Observable } from "rxjs";

@Component({
  selector: "siu-tree-picker",
  templateUrl: "./tree-picker.component.html",
  styleUrls: ["./tree-picker.component.scss"]
})
export class TreePickerComponent implements OnInit, OnChanges {
  @Input() data: ITreePickerChildren;
  @Input() offsetText: number = 24;
  @Input() offsetTextIncrement: number = 20;
  @Input() initExpanded: boolean = false;
  @Input() maxHeight: number;
  @Input() inputLabel: string;
  @Input() outputLabel: string;
  @Output("on-change") onChangeEvent: EventEmitter<any> = new EventEmitter();
  @Input() direction: "ltr" | "rtl" = "ltr";
  @Input() hideParentButtons: boolean = false;

  @Input() defaultSelected: any[];
  @Input() checkBeforeRemove: (item) => Observable<boolean> = null;
  @Input() checkBeforeAdd: (item) => Promise<boolean> = null;

  /**
   * Función que se utiliza para comparar
   */
  @Input() compareValueFn: (TreeItemValue: any, defaultValue: any) => boolean;

  $$data: ITreePickerChildren;
  $$outputData: ITreePickerChildren;
  $$dataOnList: { [prop: string]: ITreePickerElement } = {};
  $$outputDataOnList: { [prop: string]: ITreePickerElement } = {};
  @Input() readonly: boolean = false;

  constructor() {}

  ngOnInit() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.data && changes.data.currentValue) {
      this.buildWorkData();
      this.resetOutputData();
    }

    if (
      changes.data &&
      changes.data.currentValue &&
      changes.defaultSelected &&
      changes.defaultSelected.currentValue
    ) {
      this.defaultSelected.forEach(val => {
        const keyFound = Object.keys(this.$$dataOnList).find(key =>
          this.compareValueFn(this.$$dataOnList[key].value, val)
        );

        if (keyFound) {
          this.HandleAdd(this.$$dataOnList[keyFound]);
        }
      });
    }
  }

  buildWorkData = () => {
    this.$$data = JSON.parse(JSON.stringify(this.data));
    this.$$dataOnList = {};
    this.buildWorkDataChildren(this.$$data, null, null);
  };

  buildWorkDataChildren = (
    children: ITreePickerChildren,
    parentId: string,
    parent: ITreePickerElement
  ) => {
    if (children.items) {
      children.items.forEach(x => {
        const id = generateRandomString();
        x.$$node = {
          parentId: parentId,
          //parent: parent,
          open: this.initExpanded,
          id: id,
          checked: false,
          visible: true
        };

        this.$$dataOnList[id] = x;
        this.$$dataOnList[id].$$node;

        if (x.children) this.buildWorkDataChildren(x.children, id, x);
      });
    }
  };

  resetOutputData = () => {
    this.$$outputData = null;
    this.$$outputDataOnList = {};
  };

  buildOutputDataChildren = (children: ITreePickerChildren) => {
    if (children.items) {
      children.items.forEach(x => {
        x.$$selected = false;
        this.$$outputDataOnList[x.$$node.id] = x;
        if (x.children) this.buildOutputDataChildren(x.children);
      });
    }
  };

  HandleAdd = (e: ITreePickerElement) => {
    const add = () => {
      //this.$$outputDataOnList[ e.$$node.id ].$$selected = true;
      this.$$dataOnList[e.$$node.id].$$node.disabled = true;
      this.disableParent(this.$$dataOnList[e.$$node.id].$$node.parentId);
      this.disableChildren(this.$$dataOnList[e.$$node.id].children);

      /*
    if (!this.$$outputDataOnList[ e.$$node.id ]) {
      this.$$outputDataOnList[ e.$$node.id ] = e;
      this.$$outputDataOnList[ e.$$node.id ].$$selected = true;
    }*/

      const element = this.buildOutputTree(e, null);

      //this.$$outputData = { items: [ element ] };
      if (!this.$$outputData) {
        this.$$outputData = { items: [element] };
      } else {
        const index = this.$$outputData.items.findIndex(
          x => x.$$node.id == element.$$node.id
        );

        if (index == -1) {
          this.$$outputData = update(this.$$outputData, {
            items: { $push: [element] }
          });
        } else {
          this.$$outputData = update(this.$$outputData, {
            items: { [index]: { $set: element } }
          });
        }
      }
      //this.openParentOnOutput(this.$$outputDataOnList[ e.$$node.id ].$$node.parentId);
      this.emitChange();
    };

    if (this.checkBeforeAdd) {
      this.checkBeforeAdd(e.value).then(canAdd => {
        if (canAdd) add();
      });
    } else {
      add();
    }
  };

  buildOutputTree = (e: ITreePickerElement, child: any): ITreePickerElement => {
    let node = JSON.parse(JSON.stringify(e));
    node.children = null;

    if (child != null) {
      if (this.$$outputDataOnList[node.$$node.id]) {
        const existChild = !this.$$outputDataOnList[
          node.$$node.id
        ].children.items.find(x => x.$$node.id == child.$$node.id);

        if (existChild) {
          this.$$outputDataOnList[node.$$node.id].children.items.push(child);
        }
      } else {
        node.children = { items: [child] };
        this.$$outputDataOnList[node.$$node.id] = node;
      }
    } else {
      if (!this.$$outputDataOnList[node.$$node.id]) {
        node.$$selected = true;
        this.$$outputDataOnList[node.$$node.id] = node;
      } else {
        this.$$outputDataOnList[node.$$node.id].$$selected = true;
      }
    }

    if (node.$$node.parentId) {
      return this.buildOutputTree(
        this.$$dataOnList[node.$$node.parentId],
        this.$$outputDataOnList[node.$$node.id]
      );
    } else {
      return this.$$outputDataOnList[node.$$node.id];
    }
  };

  /*getParent = (e: ITreePickerElement): ITreePickerElement => {
    if (e.$$node.parent)
  }*/

  disableParent = id => {
    if (id) {
      this.$$dataOnList[id].$$node.disabled = true;
      this.disableParent(this.$$dataOnList[id].$$node.parentId);
    }
  };

  disableChildren = (children: ITreePickerChildren) => {
    if (children) {
      children.items.forEach(x => {
        x.$$node.disabled = true;
        this.disableChildren(x.children);
      });
    }
  };

  openParentOnOutput = id => {
    if (id) {
      this.$$outputDataOnList[id].$$node.open = true;
      this.openParentOnOutput(this.$$outputDataOnList[id].$$node.parentId);
    }
  };

  HandleRemove = (e: ITreePickerElement) => {
    const remove = () => {
      this.$$outputDataOnList[e.$$node.id].$$selected = false;

      if (e.$$node.parentId) {
        const indexChildren = this.$$outputDataOnList[
          e.$$node.parentId
        ].children.items.findIndex(x => x.$$node.id == e.$$node.id);
        this.$$outputDataOnList[e.$$node.parentId].children.items.splice(
          indexChildren,
          1
        );

        if (
          this.$$outputDataOnList[e.$$node.parentId].children.items.length == 0
        ) {
          const parentNode = this.$$outputDataOnList[e.$$node.parentId];

          if (parentNode.$$node.parentId) {
            const indexParent = this.$$outputDataOnList[
              parentNode.$$node.parentId
            ].children.items.findIndex(
              x => x.$$node.id == parentNode.$$node.id
            );

            this.$$outputDataOnList[
              parentNode.$$node.parentId
            ].children.items.splice(indexParent, 1);
          } else {
            const indexParent = this.$$outputData.items.findIndex(
              x => x.$$node.id == parentNode.$$node.id
            );
            this.$$outputData.items.splice(indexParent, 1);
          }
        }
      } else {
        this.resetOutputData();
      }

      this.$$dataOnList[e.$$node.id].$$node.disabled = false;
      this.enableParent(this.$$dataOnList[e.$$node.id].$$node.parentId);
      this.enableChildren(this.$$dataOnList[e.$$node.id].children);

      if (!this.existsSelectedInOutput()) {
        this.resetOutputData();
      }

      this.emitChange();
    };

    if (this.checkBeforeRemove) {
      this.checkBeforeRemove(e.value).subscribe(canRemove => {
        if (canRemove) remove();
      });
    } else {
      remove();
    }
  };

  enableParent = id => {
    if (id && this.$$outputDataOnList[id].children) {
      const childrenSelecteds = this.$$outputDataOnList[
        id
      ].children.items.filter(
        x =>
          x.$$selected ||
          (x.children && x.children.items && x.children.items.length > 0)
      ).length;

      if (childrenSelecteds == 0) {
        this.$$dataOnList[id].$$node.disabled = false;
        this.enableParent(this.$$dataOnList[id].$$node.parentId);
      }
    }
  };

  enableChildren = (children: ITreePickerChildren) => {
    if (children) {
      children.items.forEach(x => {
        x.$$node.disabled = false;
        this.enableChildren(x.children);
      });
    }
  };

  emitChange = () => {
    if (!this.data) {
      this.onChangeEvent.emit({ treeSelected: null, selectedValues: null });
      return;
    }
    const aux: ITreePickerChildren = JSON.parse(
      JSON.stringify(this.$$outputData)
    );
    let selectedValues = [];

    const proccess = (children: ITreePickerChildren) => {
      if (children) {
        children.items.forEach(x => {
          if (x.$$selected) selectedValues.push(x.value);
          delete x.$$node;
          proccess(x.children);
        });
      }
    };

    proccess(aux);

    this.onChangeEvent.emit({ treeSelected: aux, selectedValues });
  };

  existsSelectedInOutput = (): boolean => {
    const arrSelected = Object.keys(this.$$outputDataOnList).filter(
      key => this.$$outputDataOnList[key].$$selected
    );
    return arrSelected.length > 0;
  };

  /**
   * Realiza la búsqueda de un valor en el lado izquierdo
   */

  handleFilterInputLeftSide = val => {
    this.handleFilter(val, this.$$dataOnList);
  };

  /**
   * Realiza la búsqueda de un valor en el lado derecho
   */

  handleFilterInputRightSide = val => {
    this.handleFilter(val, this.$$outputDataOnList);
  };

  /**
   * Realiza la búsqueda de un valor en todos los
   * nodos por el campo label.
   * Iniciliza todos los elementos del arbol en
   * visible = false
   */

  private handleFilter = (val, dataOnList) => {
    const lastLevelNodes = Object.keys(dataOnList).filter(key => {
      dataOnList[key].$$node.visible = false;
      return !dataOnList[key].children;
    });

    lastLevelNodes.forEach(key => {
      this.findValueOnNode(
        dataOnList,
        dataOnList[key],
        val ? val.toLowerCase() : ""
      );
    });
  };

  /**
   * Busca el valor en un nodo, si lo encuentra marca
   * a todos sus padres como visible = true.
   * Si no lo encuentra, vuelve a buscar en su nodo padre.
   */
  private findValueOnNode = (
    dataOnList: any,
    element: ITreePickerElement,
    val: string
  ) => {
    const find = element.label.toLowerCase().includes(val);

    if (find) {
      this.markTreeElementAsVisible(dataOnList, element);
    } else {
      if (element.$$node.parentId) {
        this.findValueOnNode(
          dataOnList,
          dataOnList[element.$$node.parentId],
          val
        );
      }
    }
  };

  /**
   * Busca el valor en un nodo, si lo encuentra marca
   * a todos sus padres como visible = true
   */
  private markTreeElementAsVisible = (
    dataOnList: any,
    element: ITreePickerElement
  ) => {
    element.$$node.visible = true;
    if (element.$$node.parentId) {
      this.markTreeElementAsVisible(
        dataOnList,
        dataOnList[element.$$node.parentId]
      );
    }
  };
}
